import {
  Swiper,
  Pagination,
  Autoplay,
  Thumbs,
  Navigation
} from 'swiper';
Swiper.use([Pagination, Autoplay, Thumbs, Navigation]);
$(document).ready(function () {

  //print recipe
  $('.printPage').on('click', function (e) {
    e.preventDefault;
    window.print();
    return false;
  });



  //forms
  $('#contact-form form').on('submit', function (e) {
    var $form = $(this);
    $.ajax({
      type: 'POST',
      async: true,
      url: '/contact#contact_form',
      data: $form.serialize(),

      beforeSend: function () {
        $form.addClass('sending');
      },

      error: function (data) {
        console.log('error: ', data);
        $form.addClass('error');

        // 429 error - too many requests
        if (data.status == 429) {
          // Allow for default redirect to challenge form, do not force
          console.log('Allow default window redirection for challenge');
        } else {
          e.preventDefault(); // if fields are empty, paste errors
          $form.before("<div class='errors'>" + response.statusText + "</div>");
        }
      },

      success: function (data) {
        e.preventDefault(); // prevent default if successful and challenge is not needed
        console.log('success: ', data);
        $form.addClass('success');
        $form.fadeOut(300, function () {
          $form.closest('div').append('Thank You');
        });
      }
    });
  });

  // howto
  $('#how-to-nav button').on('click', function (e) {
    e.preventDefault;
    let id = $(this).data('argument')
    console.log(id)
    $('#how-to-nav button').removeClass('active');
    $(this).addClass('active');
    $('#how-to-hero .hero-wrapper').removeClass('active');
    $('#' + id + '-hero').addClass('active');

    $('.how-to-container').removeClass('active');
    $('#how-to-' + id).addClass('active');
  });

  //address

  $('.btn-modal.cta').on('click', function (e) {
    let form = $(this).closest('.address-modal').find('form');
    form.submit();
  });

  $('.address-modal').on('show.bs.modal', function () {
    let option = $((this), '.address-country').find(":selected");
    let provinces = option.data('provinces');
    if (provinces.length > 0) {
      let select = $(this).find('.address-province-select');
      let selected = $(this).find('.address-province-select').data('default');
      console.log(selected)
      provinces.forEach(element => {
        if (selected == element[0]) {
          select.append('<option value="' + element[0] + '" selected>' + element[1] + '</option>');
        } else {
          select.append('<option value="' + element[0] + '">' + element[1] + '</option>');
        }

      });
      $(this).find('.address-province').show();
    }
  })

  $('.address-country').on('change', function (e) {
    let option = $(this).find(":selected");
    let provinces = option.data('provinces');
    if (provinces.length > 0) {
      let select = $(this).closest('form').find('.address-province-select');
      select.html('');
      provinces.forEach(element => {
        select.append('<option value="' + element[0] + '">' + element[1] + '</option>');
      });
      $(this).closest('form').find('.address-province').show();
    } else {
      let select = $(this).closest('form').find('.address-province-select');
      select.html('');
      $(this).closest('form').find('.address-province').hide();
    }
  });

  // login

  $('.toggle-recover-form').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.form-login-wrapper').removeClass('active');
    $('.form-recover').addClass('active');
  });

  $('.toggle-login-form').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.form-login-wrapper').removeClass('active');
    $('.form-login').addClass('active');
  });

  //cart

  $(document).on("click", '.add-to-cart-btn', function (e) {
    // console.log(e)
    e.preventDefault();
    let qty_input = $("#Quantity");
    let selling_plan_id = 0;
    let variant_id = $(this).closest("form").find(".product_id").val() || $(this).closest("form").find("#product-options").find("input:checked").val();
    // console.log(variant_id)
    let subscribing = $('input[name="selling_plan"]').val();
    if (subscribing != '' || subscribing != undefined) {
      selling_plan_id = subscribing;
    }
    let button = $(this);
    let qty_total = qty_input ? qty_input.val() : 1;
    button.find('.button-text').html('Adding...');
    button.val('Adding...');
    // console.log(selling_plan_id);
    addItemToCart(variant_id, qty_total, button, selling_plan_id);
  });

  $(document).on("click", '.variant-price-option', function (e) {
    const price = e.target.dataset.price
    $(".price-wrapper").text(price);
  })

  $('.qty-btn').on('click', function (e) {
    e.preventDefault();
    let method = $(this).data('method');
    let input = $(this).closest('.input-group').find('input')
    let value = input.val();
    let currentVariant = $(this).data('variant');
    let index = parseInt($(this).data('index'));

    if (method == 'add') {
      value = parseInt(value) + 1
      input.val(value);
    } else {
      if (value > 0) {
        value = parseInt(value) - 1
        input.val(value);
      }
    }

    if (!this.classList.contains("qty-btn--product")) {
      let settings = {
        'async': false,
        'crossDomain': true,
        'url': '/cart/change.js',
        'dataType': 'json',
        'method': 'POST',
        'data': { quantity: value, id: currentVariant }
      };
      $.ajax(settings).done(function (response) {
        if (!response.item_count) {
          window.location.href = '/cart'
        }
        updateCart()
        let itemsArray = [];
        let linePrice = '';
        response.items.forEach(element => {
          itemsArray.push('product-' + element.product_id)
          if (element.product_id == index) {
            linePrice = element.final_line_price
          }
        });
        $('.cart-row').each(function () {
          if (!itemsArray.includes(this.id)) {
            $('#' + this.id).remove();
          }
        });
        $('#total-' + currentVariant).html(Shopify.formatMoney(linePrice))
        // $('#total-price').html(Shopify.formatMoney(response.total_price))
      });
    }

    // jQuery.post('/cart/change.js', { quantity: currentVal - 1, id: currentVariant });
  });

  // mobile nav
  const $hamburger = $('.hamburger');
  const $nav = $('#mobile-nav-wrapper');
  $hamburger.on('click', function (e) {
    e.preventDefault();
    $hamburger.toggleClass('is-active');
    $nav.toggleClass('is-active');
    $('body').toggleClass('is-nav-open');
    $('#mobile-menu-text').toggle();
  });
  $('#mobile-nav-wrapper .first').on('click', function (e) {
    e.preventDefault();
    let title = $(this).data('title');
    $('#mobile-nav-wrapper .header a').html(title + '<span></span>');
  });
  $('#mobile-nav-wrapper .second-sub').on('click', function (e) {
    e.preventDefault();
    let title = $(this).data('title');
    $('#mobile-nav-wrapper .header a span').html('| ' + title);
  });
  $(document).on("click", '#mobile-nav-wrapper .back', function (e) {
    e.preventDefault();
    $('#mobile-nav-wrapper .header a span').html('');
  });

  const slinky = $('#mobile-nav').slinky()

  // sliders

  const why_navigation = new Swiper('.why-navigation-swiper', {
    slidesPerView: 2,
    spaceBetween: 20,
  });
  // go to active
  if ($(".why-navigation-swiper-slide").length) {

    $(".why-navigation-swiper-slide").each(function (index, element) {
      if ($(element).hasClass('active')) {
        console.log(index);
        why_navigation.slideTo(index, 0, false)
      }
    });

  }

  let loop = $('.hero-slider').hasClass('no-loop') ? false : true;
  const home_swiper = new Swiper('.hero-slider .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: loop,
    autoplay: {
      delay: 6500,
      disableOnInteraction: false,
    },
    speed: 1000,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const testimonials_swiper = new Swiper('#testimonials .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });


  // filter bar
  if ($('#filter-bar-form').length) {
    getCollection();
  }

  $('#filter-bar-form').on('submit', function (e) {
    e.preventDefault();
  });

  $("#filter-bar-form").change(function () {
    if ($(window).width() > 991) {
      getAllProducts();

    }
  });

  $(document).on("change", '.variant-selector', function (e) {
    $(this).closest('.product-box').find('.product_id').val($(this).val())
  });

  $(document).on("change", '#order-by-selector', function (e) {
    getAllProducts()
  });

  $('.filter-type-wrapper button.toggle').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).closest('.filter-type-wrapper').find('ul').slideToggle();
  });

  $('#clear-all').on('click', function (e) {
    e.preventDefault();
    // $(":checkbox").attr("checked", false);
  });

  $('#mobile-filters-toggle').on('click', function (e) {
    e.preventDefault();
    $('.filter-type-wrapper ul').show();
    $('#shopify-section-filters-bar').show();
    $('body').addClass('is-nav-open');
  });

  $('#close-mobile-filters').on('click', function (e) {
    e.preventDefault();
    $('#shopify-section-filters-bar').hide();
    $('.filter-type-wrapper ul').hide();
    $('body').removeClass('is-nav-open');
  });

  $('#mobile-apply').on('click', function (e) {
    e.preventDefault();
    $('#shopify-section-filters-bar').hide();
    $('body').removeClass('is-nav-open');
    getAllProducts();
  });

  $('#filter-bar-form').on('change', function () {
    let categoryVals = [];
    let tagVals = [];
    categoryVals = $('#filter-bar-form .category:checkbox:checked').map(function () {
      return this.value;
    }).get();
    tagVals = $('#filter-bar-form .tags:checkbox:checked').map(function () {
      return this.value;
    }).get();
    let filtersCount = categoryVals.length + tagVals.length;
    if (filtersCount > 0) {
      $('#mobile-clear span').html('[' + filtersCount + ']')
    } else {
      $('#mobile-clear span').html('')
    }
  });

  $('#mobile-clear').on('click', function (e) {
    e.preventDefault();
    $('#filter-bar-form input[type=checkbox]').prop('checked', false);
    $('#mobile-clear span').html('');
    $('#shopify-section-filters-bar').hide();
    $('body').removeClass('is-nav-open');
    getAllProducts();
  });

  $('#clear-all').on('click', function (e) {
    e.preventDefault();
    $('#filter-bar-form input[type=checkbox]').prop('checked', false);
    getAllProducts();
  });

  // product page
  $(".accordion-product-button").on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).closest('.accordion-wrapper').find('.accordion-container').slideToggle();
  });

});


function getAllProducts() {
  $('#products-list-row').html('<div class="col-12 text-center"><div class="spinner-border" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div></div>');
  let categoryVals = [];
  let tagVals = [];
  let products = [];
  categoryVals = $('#filter-bar-form .category:checkbox:checked').map(function () {
    return this.value;
  }).get();

  tagVals = $('#filter-bar-form .tags:checkbox:checked').map(function () {
    return this.value;
  }).get();

  let filtersCount = categoryVals.length + tagVals.length;
  if (filtersCount > 0) {
    $('#mobile-filters-toggle span').html('[' + filtersCount + ']')
  } else {
    $('#mobile-filters-toggle span').html('')
  }

  let sort = $("#order-by-selector").val();
  if (sort == 'FEATURED') {
    sort = null;
  }

  if (categoryVals.length) {
    categoryVals.forEach(handle => {
      // console.log(handle, sort);
      let query = `
      query {
        collection(handle:"`+ handle + `") {
          collection_separator_image: metafield(namespace: "collection", key: "collection_separator_image") {
            value
          }
          products(first: 100,sortKey:`+ sort + `) {
          edges {
            node {
              id
              handle
              title
              onlineStoreUrl
              tags
              availableForSale
              product_oz: metafield(
                namespace: "airf"
                key: "product_oz"
              ) {
                  value
              }
              custom_badge_line1: metafield(
                namespace: "products"
                key: "custom_badge_line1"
              ) {
                  value
              }
              custom_badge_line2: metafield(
                namespace: "products"
                key: "custom_badge_line2"
              ) {
                  value
              }
              custom_badge_color: metafield(
                namespace: "products"
                key: "custom_badge_color"
              ) {
                  value
              }
              custom_badge_border: metafield(
                namespace: "products"
                key: "custom_badge_border"
              ) {
                  value
              }
              custom_compare_at_price: metafield(
                namespace: "product"
                key: "custom_compare_at_price"
              ) {
                  value
              }
              images(first: 1) {
                edges {
                  node {
                    id
                    originalSrc
                    small: transformedSrc(maxWidth: 400)
                  }
                }
              }
              variants(first: 10) {
                edges {
                  node {
                    availableForSale
                    id
                    title
                    priceV2{
                      currencyCode:currencyCode
                      amount
                    }
                    compareAtPriceV2{
                      currencyCode:currencyCode
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      }
      }
      `;
      let settings = {
        'async': false,
        'crossDomain': true,
        'url': 'https://great-lakes-gelatin-2.myshopify.com/api/2022-10/graphql.json',
        'method': 'POST',
        'headers': {
          'X-Shopify-Storefront-Access-Token': '422cb4918e74d85a385d6116c01baa1b',
          'Content-Type': 'application/graphql',
        },
        'data': query
      };

      $.ajax(settings).done(function (response) {
        // console.log("response: ", response)
        if (response.data.collection) {
          response.data.collection.products.edges.forEach(product => {
            products.push(product.node)
          });
        }
        // setCollectionLoopImage(response)
        updateProductList(products, tagVals);
      });
    });
  } else {
    let collection = $('#defaultCollection').val();
    console.log(collection, sort)
    let query = `
    query {
      collection(handle:"`+ collection + `") {
        collection_separator_image: metafield(namespace: "collection", key: "collection_separator_image") {
          value
        }
        products(first: 100,sortKey:`+ sort + `) {
        edges {
          node {
            id
            handle
            title
            onlineStoreUrl
            tags
            availableForSale
            product_oz: metafield(
              namespace: "airf"
              key: "product_oz"
            ) {
                value
            }
            custom_badge_line1: metafield(
              namespace: "products"
              key: "custom_badge_line1"
            ) {
                value
            }
            custom_badge_line2: metafield(
              namespace: "products"
              key: "custom_badge_line2"
            ) {
                value
            }
            custom_badge_color: metafield(
              namespace: "products"
              key: "custom_badge_color"
            ) {
                value
            }
            custom_badge_border: metafield(
              namespace: "products"
              key: "custom_badge_border"
            ) {
                value
            }
            custom_compare_at_price: metafield(
              namespace: "product"
              key: "custom_compare_at_price"
            ) {
                value
            }
            images(first: 1) {
              edges {
                node {
                  id
                  originalSrc
                  small: transformedSrc(maxWidth: 400)
                }
              }
            }
            variants(first: 10) {
              edges {
                node {
                  availableForSale
                  id
                  title
                  priceV2{
                    currencyCode:currencyCode
                    amount
                  }
                  compareAtPriceV2{
                    currencyCode:currencyCode
                    amount
                  }
                }
              }
            }
          }
        }
      }
      }
    }
      `;
    let settings = {
      'async': false,
      'crossDomain': true,
      'url': 'https://great-lakes-gelatin-2.myshopify.com/api/2022-10/graphql.json',
      'method': 'POST',
      'headers': {
        'X-Shopify-Storefront-Access-Token': '422cb4918e74d85a385d6116c01baa1b',
        'Content-Type': 'application/graphql',
      },
      'data': query
    };

    $.ajax(settings).done(function (response) {
      console.log("response: ", response)
      response.data.collection.products.edges.forEach(product => {
        products.push(product.node)
      });
      // setCollectionLoopImage(response)
      updateProductList(products, tagVals);
    });

  }
}
let collectionLoopImage;
function setCollectionLoopImage(response) {
	alert( 'response ')
  if (response.data.collection.collection_separator_image) {
    let val = JSON.parse(response.data.collection.collection_separator_image.value);
    collectionLoopImage = val[0].src;
  }
}

function updateProductList(products, tagVals) {
	// console.log( products )
  let filteredProduct = products;
  if (tagVals.length) {
    filteredProduct = filterProductsbyTag(products, tagVals)
  }

  // wholesale distributor
  let customerTags = $('#customerTags').val().split(',');
  let distributor = false;
  if (customerTags.includes('distributor') || customerTags.includes('grocer')) {
    distributor = customerTags.includes('accepted') ? true : false;
  }
  let wholesale = false;
  if (customerTags.includes('wholesale')) {
    wholesale = customerTags.includes('accepted') ? true : false;
  }

  if (!wholesale) {
    let index = 0;
    let removeValFrom = [];
    filteredProduct.forEach(element => {
      if (element.tags.includes('wholesale')) {
        removeValFrom.push(index);
      }
      index++;
    });
    if (removeValFrom.length > 0) {
      filteredProduct = filteredProduct.filter(function (value, index) {
        return removeValFrom.indexOf(index) == -1;
      })
    }
  }

  if (!distributor) {
    let index = 0;
    let removeValFrom = [];
    filteredProduct.forEach(element => {
      if (element.tags.includes('distributor')) {
        removeValFrom.push(index);
      }
      index++;
    });
    if (removeValFrom.length > 0) {
      filteredProduct = filteredProduct.filter(function (value, index) {
        return removeValFrom.indexOf(index) == -1;
      })
    }
  }

  $('#number-of-products').html(filteredProduct.length + ' products')
  let content = '';
  if (filteredProduct.length > 0) {

    let index = 0;
    filteredProduct.forEach(product => {
      // if (index == 6) {
      //   content += '<div class="col-12 col-md-8 loop-image">';
      //   if (collectionLoopImage) {
      //     // console.log("collectionLoopImage: ", collectionLoopImage)
      //     content += '<img class="img-fluid" src="' + collectionLoopImage + '">';
      //   } else {
      //     content += '<img class="img-fluid" src="//cdn.shopify.com/s/files/1/0026/8537/0428/files/try-new-products.png?v=1639779900">';
      //   }
      //   content += '</div>';
      // }
      content += '<div class="col-6 col-md-4 mb-5 d-flex justify-content-center">';
      content += '<div class="product-box text-center d-flex justify-content-center flex-wrap">';
      content += '<a href="/products/' + product.handle + '"><figure class="hover-zoom"><img class="img-fluid" src="' + product.images.edges[0].node.small + '" alt="' + product.title + '"></figure></a>';
      content += '<div class="w-100"></div>';

			if (product.custom_badge_line1 != null || product.custom_badge_line2 != null) {
				let badge_color = "#00382a";
				let badge_border = "#a6ce39";
				if (product.custom_badge_color != null) {
					badge_color = product.custom_badge_color.value.replace('["', ' ');
					badge_color = badge_color.replace('"]', ' ');
				}
				if (product.custom_badge_border != null) {
					badge_border = product.custom_badge_border.value.replace('["', ' ');
					badge_border = badge_border.replace('"]', ' ');
				}
				content += '<div class="product-custom_badge" style="background: ' + badge_color + ';border-bottom-color: ' + badge_border + '">';


				if (product.custom_badge_line1 != null) {
					let line1 = product.custom_badge_line1.value.replace('["', ' ');
					line1 = line1.replace('"]', ' ');
					content += '<span class="line1">' + line1 + '</span><br>';
				}

				if (product.custom_badge_line2 != null) {
					let line2 = product.custom_badge_line2.value.replace('["', ' ');
					line2 = line2.replace('"]', ' ');
					content += '<span class="line2">' + line2 + '</span>';
				}

				content += '</div>';
			}

      content += `<div class="w-100 mb-2" style="display:flex;justify-content:center;"><div class="yotpo bottomLine" data-product-id="${product.id.split("Product/")[1]}"></div></div>`;

      // if(product.product_oz){
      //   content += '<span class="d-block oz">'+product.product_oz.value+' OZ.</span>';
      // }

      content += '<div class="w-100"></div>';
      content += '<h3 class="mb-0"><a href="/products/' + product.handle + '">' + product.title + '</a></h3>';
      content += '<div class="w-100"></div>';

      // if (product.variants.edges.length > 1) {
        // content += '<select class="form-control mt-3 variant-selector" id="price-select-' + index + '">';

        // let i = 0;
				// product.variants.edges.forEach(variant => {
				// 	let selected = i == 0 ? 'selected' : '';
				// 	let title = variant.node.title ;
				// 	let disabled = '';
				// 	if (!variant.node.availableForSale) {
				// 		title += ' - Sold Out'
				// 		disabled = ' disabled ';
				// 	}
				// 	title+= ' - ' + Shopify.formatMoney(variant.node.priceV2.amount)
				// 		content += '<option '+ selected + disabled +' value="' + atob(variant.node.id).split('ProductVariant/')[1] + '">' + title +  '</option>';
        //   i++;
        // });



        // let i = 0;
        // product.variants.edges.forEach(variant => {
        //   i++;
        //   if (variant.node.availableForSale) {
        //     content += '<option value="' + atob(variant.node.id).split('ProductVariant/')[1] + '">' + variant.node.title + ' - ' + Shopify.formatMoney(variant.node.priceV2.amount) + '</option>';
        //   } else {
        //     if (i == 1) {
        //       content += '<option disabled selected value="' + atob(variant.node.id).split('ProductVariant/')[1] + '">' + variant.node.title + ' - ' + 'Sold Out' + '</option>';
        //     } else if (i > 1) {
        //       content += '<option disabled value="' + atob(variant.node.id).split('ProductVariant/')[1] + '">' + variant.node.title + ' - ' + 'Sold Out' + '</option>';
        //     }
        //   }
        // });
        // content += '</select>';
      // } else {
				let onSale = false
        if (product.variants.edges[0].node.compareAtPriceV2) {
          onSale = true;
          content += '<span class="d-inline-block mr-2 price-compared">' + Shopify.formatMoney(product.variants.edges[0].node.compareAtPriceV2.amount) + '</span>';
          content += '<span class="d-inline-block price-bold on-sale">' + Shopify.formatMoney(product.variants.edges[0].node.priceV2.amount * 100) + '</span>';
				}
        // if (product.custom_compare_at_price) {
        //   content += '<span class="d-inline-block mr-2 price-compared">' +  Shopify.formatMoney(product.variants.edges[0].node.priceV2.amount)  + '</span>';
        //   content += '<span class="d-inline-block price-bold">' + product.custom_compare_at_price.value + '</span>';
				// 	onSale = true;
				// }
				if( !onSale ) {
          content += '<span class="d-inline-block price-bold">' + Shopify.formatMoney(product.variants.edges[0].node.priceV2.amount * 100) + '</span>';
        }
      // }

      content += '<div class="w-100"></div>';
      content += '<div class="w-100"></div>';
      content += '<form method="post" action="/cart/add" class="ajax-add-to-cart mt-3 align-self-end">';
      content += '<input type="hidden" name="id" id="product-id-' + index + '" class="product_id" value="' + product.variants.edges[0].node.id.split('ProductVariant/')[1] + '" />';
      content += '<input min="1" type="hidden" id="quantity-' + index + '" name="quantity" class="product_quantity" value="1"/>';
			// console.log( product , product.variants.edges[0].node )
      // content += '<input type="submit" value="Add To Cart" class="add-to-cart-btn" />';
      if ( product.availableForSale && product.variants.edges[0].node.availableForSale ) {
        content += '<input type="submit" value="Add To Cart" class="add-to-cart-btn" />';
      } else {
        content += '<input type="submit" disabled value="Sold Out" class="add-to-cart-btn" />';
      }

      content += '</form>'
      content += '</div></div>';

      index++;

    });

  } else {
    content = '<div class="col-12">No products match this search criteria</div>';
  }
  $('#products-list-row').html(content)
  $(() => {
    if(window.yotpo) {
			var api = new Yotpo.API(yotpo);
			api.refreshWidgets();
		}
  })
}

function filterProductsbyTag(products, tagVals) {
  let ruturnedProducts = [];
  let filteredProducts = [];
  tagVals.forEach(tag => {
    filteredProducts = products.filter(function (product) {
      return product.tags.indexOf(tag) > -1;
    });

    if (filteredProducts.length) {
      filteredProducts.forEach(element => {
        ruturnedProducts.push(element)
      });
    }

  });

  return ruturnedProducts;
}
function getCollection() {
  $.ajax({
    type: 'GET',
    url: '/collections.json',
    dataType: 'json',
    success: function (res) {
      res.collections.forEach(collection => {
        $("#filter-bar-form .category").each(function (index) {
          let title = $(this).data('title');
          if (title.toLowerCase() == collection.title.toLowerCase()) {

            $(this).val(collection.handle);
          }
        });
      });
      getAllProducts();
    },
    error: function (status) {
      console.log(status);
    }
  })
}

function fireAddedToCartEvent(details) {
  const evt = new CustomEvent("addedItemToCart", details);
  document.dispatchEvent(evt);
}

// add item to cart
function addItemToCart(variant_id, qty, button, selling_plan_id) {
  let data = {
    "id": variant_id,
    "quantity": qty
  }

  if (selling_plan_id !== 0) {
    data.selling_plan = selling_plan_id
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function (res) {
      updateCart(button)
      showCartTray(res);
      fireAddedToCartEvent({ detail: { toggleDrawer: true } });
    },
		error: function ( res ){
			button.val('Add To Cart');
			if( ( typeof( res.responseJSON ) !== 'undefined' ) && typeof( res.responseJSON ) == 'object' ){
				alert( res.responseJSON.description )
			}else{
				alert( 'We were unable to add this item to your cart');
			}
		}
  });
  return false;
}

// SHOW CART TRAY
function showCartTray(res) {
  var cartTrayImage = res.image;
  var cartTrayProductName = res.title;
  var cartTrayQty = res.quantity;
  $('.cart-tray').addClass('show ');
  $('.cart-tray__details--image').attr('src', cartTrayImage);
  $('.cart-tray__details--image').attr('alt', cartTrayProductName);
  $('.cart-tray__details--product-name').text(cartTrayProductName);
  $('.cart-tray__details--qty span').text(cartTrayQty);
}

// CLOSE CART TRAY
$(document).ready(function () {
  $(".cart-tray__close").on("click", function () {
    $(".cart-tray").removeClass('show');
  });
});

function updateCart(button) {
  $.ajax({
    url: '/cart.js',
    dataType: 'json'
  })
    .done(function (data) {
      var newCount = data.item_count;
      if (newCount > 0) {
        $('#count-desktop').html(newCount);
        $('#count-mobile').html(newCount);
      } else {
        $('#count-desktop').html('');
        $('#count-mobile').html('');
      }
      button.val('Cart Updated');
      button.find('.button-text').html('Cart Updated');
      setTimeout(() => {
        button.val('Add To Cart');
        button.find('.button-text').html('Add To Cart');
      }, 2000);
    });
}

window.addEventListener("DOMContentLoaded", function () {
  const landing_page_reviews = new Swiper(".customer-reviews__carousel", {
		slidesPerView: 1,
		// If we need pagination
		pagination: {
			el: ".swiper-pagination",
		},
		autoplay: {
			delay: 8000,
		},
	});
})

